.orderSummary {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid #ccc;
  border-radius: 0.25rem;
  padding: 16px;
}

.orderSummaryItems {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px;
}

.orderSummaryTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.orderSummaryTotal {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: var(--haus-input-border, 0.0625rem solid #ccc);
  padding: 16px 8px 0 8px;
}
